import { render, staticRenderFns } from "./DetailStore.vue?vue&type=template&id=1fe97183&scoped=true&"
import script from "./DetailStore.vue?vue&type=script&lang=js&"
export * from "./DetailStore.vue?vue&type=script&lang=js&"
import style0 from "./DetailStore.vue?vue&type=style&index=0&id=1fe97183&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe97183",
  null
  
)

export default component.exports